import script from "./StarWars.vue?vue&type=script&setup=true&lang=js"
export * from "./StarWars.vue?vue&type=script&setup=true&lang=js"

import "./StarWars.vue?vue&type=style&index=0&id=8c98c042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c98c042"]])

export default __exports__